import React, { useEffect } from "react";
import { useLocation , useNavigate } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import { useGtm, buildAdPayload, getKstTimestamp, fetchAdPayload } from 'hooks/useGtm';
import AppSsoCallBackApi from "Apis/AppSsoCallBackApi";
const AppSsoLoginCallBack = (sso_type:string,gameSvcCd:string|null,redirectUri:string|null) => {
    const location= useLocation(); 
     const navigate = useNavigate(); 
     const { push: gtmPush } = useGtm();
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }  
    let query =serchParamsFunc();
    let code = query.get("code");
    let naverState = query.get("state");

    useEffect(()=>{
        AppSsoCallBackApi(sso_type,code,naverState,gameSvcCd,redirectUri)
        .then(async (Resp) => {
             if (!isMobile && window.opener && window.opener.AppSsoRespFunc) {
                    window.opener.AppSsoRespFunc(Resp.apiHdr.code);
                    window.close();
                }else if(isMobile) {
                    switch (Resp.apiHdr.code) {
                        case "ATHN0000":
                            if (window.fbq) {
                                window.fbq('trackCustom', 'BBO_FB_Login_Complete');
                            }
                            const tsKst = getKstTimestamp();
                            const adPayload = await fetchAdPayload( 'BBO');
                            try {
                                gtmPush('AT_GA_Login_Complete', {
                                    ts: tsKst,
                                    ...adPayload,
                                });
                            } catch (gtmErr) {
                                if (typeof window !== 'undefined') {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        event: 'AT_GA_Login_Complete',
                                        ts: tsKst,
                                        ...adPayload,
                                    });
                                }
                            }
                             // 리퍼러 파라미터가 있으면 해당 페이지로 이동
                            if(Resp.apiBody?.redirectUri.length > 0) {
                                return navigate(decodeURIComponent(Resp.apiBody.redirectUri), { replace: true });
                            }
                            navigate("/Connect/AppStrt", { replace: true });
                            break;
                        case "ATHN2002":
                            navigate("/Connect/BlckMemb", { replace: true });
                            break;
                        case "ATHN2005":
                            navigate("/Connect/membLvdCncl", { replace: true });
                            break;
                        case "ATHN2007":
                            navigate("/Connect/OtpAthn");
                            break;
                        case "ATHN2003":
                            navigate("/Connect/DrmcMemb", { replace: true });
                            break;
                        case "ATHN2009":
                            navigate(`/Connect/MembJoin`, { state: { joinTypeCd: "SSO" } });
                            break;
                    }
                }
        })
        .catch(() => {
        });
    },[]);


    return(
        <>
        </>
    )
}

export default AppSsoLoginCallBack;